import { queryOptions, useQuery } from "@tanstack/react-query";
import type { MagicLinkResponse, User } from "@tunic/shared";
import { api } from "./client";
import { qk } from "./keys";

export interface Me {
  user: User;
  auth_kind: "session" | "pat";
}

export const meQuery = queryOptions({
  queryKey: qk.me,
  queryFn: () => api.get<Me>("/api/me"),
  staleTime: 5 * 60_000,
  retry: false,
});

export const configQuery = queryOptions({
  queryKey: qk.config,
  queryFn: () => api.get<{ max_upload_mb: number; email_delivery_enabled: boolean; public_url: string }>("/api/config"),
  staleTime: Infinity,
});

export const useMe = () => useQuery(meQuery);
export const useAppConfig = () => useQuery(configQuery);

export const requestMagicLink = (email: string) =>
  api.post<MagicLinkResponse>("/api/auth/magic-link", { email, client: "web" });

export const exchangeToken = (token: string) => api.post<{ user: User }>("/api/auth/exchange", { token, client: "web" });

export const logout = () => api.post<{ ok: true }>("/api/auth/logout");
